import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { type Country, type PagedCountry } from './country.model';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiBaseUrl}/country`;

  createCountry(country: Country): Observable<string> {
    const headers = new HttpHeaders().set('X-Spinner', 'true');
    return this.http.post(`${this.apiUrl}/create`, country, {
      headers,
      responseType: 'text'
    });
  }

  updateCountry(country: Country): Observable<string> {
    const headers = new HttpHeaders().set('X-Spinner', 'true');
    return this.http.put(`${this.apiUrl}/update`, country, {
      headers,
      responseType: 'text'
    });
  }

  getCountryById(countryId: string): Observable<Country> {
    const headers = new HttpHeaders().set('X-Spinner', 'true');
    return this.http.get<Country>(`${this.apiUrl}/get/${countryId}`, { headers });
  }

  deleteCountry(countryId: string): Observable<void> {
    const headers = new HttpHeaders().set('X-Spinner', 'true');
    return this.http.delete<void>(`${this.apiUrl}/hide/${countryId}`, { headers });
  }

  getPagedCountries(page: number, size: number, active: string, name: string, code: string, sort: string): Observable<PagedCountry> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('active', active !== undefined ? active : 'all');

    if (name) {
      params = params.set('name', name.trim());
    }
    if (code) {
      params = params.set('code', code.trim());
    }
    if (sort) {
      params = params.set('sort', sort);
    }

    return this.http.get<PagedCountry>(`${this.apiUrl}/find-all-paged`, { params: params });
  }

  getCountriesForDropdown(): Observable<Country[]> {
    return this.http.get<Country[]>(`${this.apiUrl}/find-all-for-dropdown`);
  }

  getCountryLabel(country: Country): string {
    const name = country?.name ?? '';
    const code = country?.code ?? '';
    if (environment.showCode && name && code) {
      return `${name} (${code})`;
    }
    if (name) {
      return name;
    }
    if (code) {
      return `${code}`;
    }
    return '';
  }
}
